import H5 from "../../ui/Typography/Headings/H5";
import Paper from "../../ui/Paper";
import Props from "./props";
import React from "react";
import { SCHOOLS_PATH } from "../../../../constants/RoutesConstants";
import styled from "styled-components";
import useHistoryPush from "../../../../hooks/useHistoryPush";

const SchoolCard: React.FC<Props> = ({ id, name, title, order, description, categories }) => {
    const push = useHistoryPush(`${SCHOOLS_PATH}/${name}/${id}`);
    return (
        <Paper onClick={push}>
            <H5>
                {order.length ? `${order.join(".")} - ` : null}
                {title}
            </H5>
            <Description dangerouslySetInnerHTML={{ __html: description }} />
            <i>
                <strong>Categorie</strong>: {categories}
            </i>
        </Paper>
    );
};

export default SchoolCard;

const Description = styled.div`
    margin: 0.5rem 0;
`;
